import request from '../utils/request';

export const getAllComment = query => {
    return request({
        url: query.url,
        method: 'post',
        data: query.data
    });
};


export const saveComment = query => {
    return request({
        url: query.url,
        method: 'post',
        data: query.data
    });
};


